import { inventoryLevelIdFormat } from "@redotech/redo-warehouse-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setFulfillmentGroupPickedQuantities = {
  name: "setFulfillmentGroupPickedQuantities" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    updates: z.array(
      z.object({
        fulfillmentOrderLineItemExternalId: z.string(),
        quantityPicked: z.number().int().min(0),
        sources: z
          .array(
            z.discriminatedUnion("type", [
              z.object({
                type: z.literal("inventoryLevel"),
                inventoryLevelId: inventoryLevelIdFormat.schema,
                quantity: z.number().int().min(1),
              }),
              z.object({
                type: z.literal("external"),
                quantity: z.number().int().min(1),
              }),
            ]),
          )
          .nullish(),
      }),
    ),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().nullish(),
    // Set when an increase was refused because the product requires a
    // picker-entered lot and the problem session has none for it.
    needsLot: z.boolean().optional(),
    needsLotItemId: zExt.objectId().optional(),
    pickSessionItemStatuses: z
      .array(
        z.object({
          fulfillmentOrderLineItemExternalId: z.string(),
          quantityPicked: z.number(),
        }),
      )
      .nullish(),
  }),
};
